import p, { useState as H, useMemo as s, useCallback as d, useEffect as V } from "react";
import { MemoryRouter as _, useNavigate as $, useLocation as B, matchPath as D } from "react-router-dom";
import { useStyle as G } from "../../../dom/hooks/useStyle.js";
import { useTranslation as I } from "react-i18next";
import { paths as T } from "./paths.js";
import { Context as q } from "./context.js";
function z({
  children: m,
  navigationConfig: a,
  scope: y,
  utmReferral: b,
  defaultPage: v
}) {
  const [r, n] = H([]), [k, P] = H(!1), { t: w } = I(), c = $(), l = B(), E = () => {
    P(!1), n([]);
  }, O = (e) => {
    n((o) => [...o, e]);
  }, u = s(
    () => Object.entries(a).map(([e, o]) => {
      var R, g;
      const i = e, S = o;
      return [e, (g = (R = T)[i]) == null ? void 0 : g.call(R, S, w)];
    }).filter((e) => !!e[1]),
    [a]
  ), h = s(
    () => u.flatMap((e) => e[1]),
    [u]
  ), f = s(() => h.map((e) => e.path), [h]), t = s(() => {
    if (v === void 0) return;
    const e = u.find((i) => i[0] === v);
    if (e === void 0) return;
    const o = e[1].filter((i) => !i.path.includes(":"));
    if (f.length !== 0)
      return o[0].path;
  }, [v, u]), j = d(
    (e) => f.some((o) => D(o, e) !== null),
    [f]
  ), M = d((e, o) => {
    if (!j(e))
      throw new Error(`Path \`${e}\` is not available, please use one of the following: ${f.join(", ")}`);
    r[r.length - 1] !== e && (P(!0), c(e), o != null && o.overrideHistory ? n([e]) : O(e));
  }, [r]), x = d(() => {
    r.length <= 1 ? t !== void 0 ? (c(t), n([t])) : E() : (c(-1), n((e) => e.slice(0, -1)));
  }, [r, t, c]), N = s(() => !!(r.length > 1 || t && l.pathname !== t), [r, l.pathname, t]);
  V(() => {
    t && M(t, {
      overrideHistory: !0
    });
  }, [t]);
  const L = s(() => ({
    navigate: M,
    history: r,
    back: x,
    close: E,
    isNavigationOpen: k,
    navigationConfig: a,
    location: l,
    scope: y,
    utmReferral: b,
    routes: h,
    defaultPath: t,
    canGoBack: N
  }), [r, a, l, y, b, t, N]);
  return /* @__PURE__ */ p.createElement(q.Provider, { value: L }, m);
}
function U(m) {
  return G("https://statics.cheerfy.com/admin/css/fonts/lineicons/LineIconsCustom.css"), /* @__PURE__ */ p.createElement(_, null, /* @__PURE__ */ p.createElement(z, { ...m }));
}
export {
  U as NavigationProvider,
  z as NavigationProviderRoot
};
//# sourceMappingURL=provider.js.map
